import { useState } from "react";
import { useAsyncData } from "../../../hooks/useAsyncData";
import { getDocumentStats, type AdmissionRecheckScope } from "../../../lib/corpusApi";
import { countDocumentsInScope } from "./document_scopes";

/** A chosen document scope and how many documents it covers. */
export interface DocumentScopeState {
  scope: AdmissionRecheckScope;
  setScope: (scope: AdmissionRecheckScope) => void;
  /** Documents the chosen scope currently covers, from DocumentStats. Null until stats load. */
  scopeCount: number | null;
}

/** The scope a batch job over existing corpus documents is started on, with the size of that scope
 *  as it stands. */
export function useDocumentScope(initial: AdmissionRecheckScope): DocumentScopeState {
  const [scope, setScope] = useState<AdmissionRecheckScope>(initial);
  const { data: stats } = useAsyncData(() => getDocumentStats());
  return { scope, setScope, scopeCount: countDocumentsInScope(stats, scope) };
}
